"use client";

import React from "react";
import Image from "next/image";
import { Toaster } from "@/components/ui/sonner";

interface AuthLayoutProps {
  children: React.ReactNode;
}

function AuthCover() {
  return (
    <aside className="relative hidden shrink-0 flex-col overflow-hidden bg-authCover px-9 py-10 text-white md:flex md:min-h-dvh md:w-[30%] md:max-w-[520px]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-[-10%] -z-10 blur-xl bg-[image:var(--auth-cover-glow)]"
      />
      <Image
        src="/ImplementAI_main_logo_dark.svg"
        alt="Implement AI"
        width={160}
        height={32}
        className="relative z-10 mb-14 h-auto w-40"
        priority
      />
      <h2 className="relative z-10 mt-auto mb-4 text-[clamp(28px,2.8vw,42px)] font-extrabold leading-tight tracking-tight">
        Grow your workforce.
        <span className="block text-authCoverAccent">Not your payroll.</span>
      </h2>
      <p className="relative z-10 mb-auto max-w-[420px] text-[15px] leading-relaxed text-white/80">
        AI Agents that work in the real world — handling support, sales, and
        operations alongside your team, 24/7.
      </p>
    </aside>
  );
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-dvh w-full min-w-0 max-w-full flex-col bg-background md:flex-row">
      <AuthCover />

      <section className="flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col overflow-y-auto overscroll-y-contain bg-background px-6 py-5 lg:px-14 lg:py-6">
        <div className="flex w-full flex-1 flex-col items-center justify-center">
          <div className="w-full max-w-[440px] py-2">{children}</div>
        </div>
      </section>

      <Toaster position="bottom-right" />
    </div>
  );
}
